import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import {
  Select,
  Option,
  Chip,
  DialogHeader,
  DialogFooter,
  DialogBody,
} from "@material-tailwind/react";
import React from "react";
import {
  UserPlusIcon,
  PencilIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/solid";
import {
  Dialog,
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
} from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAuditData,
  getEvidenceTaskData,
  getSingleEvidenceDataForUpdate,
  updateEvidenceData,
} from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import toast from "react-hot-toast";
import ExcelJS from "exceljs";
import TableRowWithShowMore from "../../components/TableRowWithShowMore";
import moment from "moment";

const TABLE_HEAD = [
  "Id",
  "Audit",
  "Requirements",
  "Assigned To",
  "Status",
  "Created On",
  "Created By",
  "Completed On",
  "Completed By",
  "Action",
];

export default function Evidence() {
  const { refreshToken, rbac } = useAuthUserToken();
  const [auditData, setAuditData] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [status, setStatus] = useState("");
  const [auditId, setAuditId] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [forEditEvidenceData, setForEditEvidenceData] = useState("");
  const [editLoading, setEditLoading] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [multipleRequirementData, setMultipleRequirementData] = useState();
  const [submitLoading, setSubmitLoading] = useState(false);

  const [editFormData, setEditFormData] = useState({
    taskRequirements: "",
    TaskAssignee: "",
    TaskCreatedOn: "",
    TaskCompletedOn: "",
    TaskStatus: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setSelectedCheckboxes((prev) =>
      checked ? [...prev, value] : prev.filter((id) => id !== value)
    );
  };

  const allSelected =
    forEditEvidenceData.TaskRequirements?.length === selectedCheckboxes.length;

  useEffect(() => {
    setEditFormData({
      taskRequirements: forEditEvidenceData?.taskRequirements || "",
      TaskAssignee: forEditEvidenceData?.TaskAssignee || "",
      TaskCreatedOn: forEditEvidenceData?.TaskCreatedOn || "",
      TaskCompletedOn: forEditEvidenceData?.TaskCompletedOn || "",
      TaskStatus: forEditEvidenceData?.TaskStatus || "",
      TaskRemarks: forEditEvidenceData?.TaskRemarks || "",
    });
  }, [forEditEvidenceData]);

  const handleSubmit = (id) => {
    setSubmitLoading(true);
    const updatedRequirements = forEditEvidenceData.TaskRequirements.map(
      (requirement) => ({
        ...requirement,
        status: editFormData.TaskStatus || requirement.status,
      })
    );

    const formattedTaskCreatedOn = forEditEvidenceData?.TaskCreatedOn
      ? moment(forEditEvidenceData.TaskCreatedOn).format("YYYY-MM-DD")
      : "";

    console.log(formattedTaskCreatedOn);

    const finalData = {
      ...editFormData,
      TaskCreatedOn: formattedTaskCreatedOn,
      TaskRequirements: updatedRequirements,
    };

    updateEvidenceData(finalData, refreshToken, id)
      .then((data) => {
        if (data?.code === 200) {
          toast.success(data?.message, {
            className: "text-[12px]",
          });
          handleClose();
        } else {
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        }
      })
      .catch((error) => {
        toast.error("An unexpected error occurred. Please try again.", {
          className: "text-[12px]",
        });
        console.error("Error updating evidence data:", error);
      })
      .finally(() => {
        setSubmitLoading(true);
        console.log("Update evidence data API call completed.");
      });
  };

  const toggleDialog = (data) => {
    setMultipleRequirementData(data);
    setIsDialogOpen(true);
  };
  const toggleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleOpenCreateDialog = () => {
    setOpenCreateDialog((cur) => !cur);
  };

  const getEvidenceDataForUpdate = (id) => {
    setEditLoading(true);
    console.log("get evidence data for update");
    getSingleEvidenceDataForUpdate(refreshToken, id)
      .then((res) => {
        if (res?.code === 200) {
          setForEditEvidenceData(res?.data);
          console.log("Evidence Update data :", res);
        }
      })
      .catch((error) => {
        console.log("Evidence Update data error:", error);
      })
      .finally(() => {
        console.log("finally");
        setEditLoading(false);
      });
  };

  const [open, setOpen] = useState(false);
  const handleOpen = (id) => {
    getEvidenceDataForUpdate(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getAuditData(refreshToken, searchBy, sortBy, 100, page).then((data) => {
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setAuditData(data?.data?.results);
      setIsLoading(false);
    });
    getEvidenceTaskData(
      refreshToken,
      searchBy,
      sortBy,
      limit,
      page,
      status,
      auditId
    ).then((data) => {
      if (data?.code === 403) {
        navigate("/403");
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      }
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setTotalPage(data?.data?.totalPages);
      setTemplateData(data?.data?.results);
      setIsLoading(false);
    });
  }, [page, limit, sortBy, searchBy, status, auditId, refreshToken, open]);

  // Create Form Functionality
  const [selectedAuditId, setSelectedAuditId] = useState("");

  const handleChangeSelect = (e) => {
    setSelectedAuditId(e);
  };

  function createEvidanceTask() {
    navigate(`/audit-evidence`, {
      state: { selectedAuditId: selectedAuditId },
    });
  }

  // End Create Form Functionality

  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Evidence Data");

    const headers = [
      "S.No.",
      "TaskId",
      "AuditId	",
      "TaskRequirements",
      "TaskAssignee",
      "TaskStatus",
      "TaskCreatedOn",
      "TaskCreatedBy",
      "TaskCompletedOn",
      "TaskCompletedBy",
    ];

    worksheet.addRow(headers);

    templateData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.TaskId,
        row.AuditId,
        row.TaskRequirements,
        row.TaskAssignee,
        row.TaskStatus,
        row.TaskCreatedOn,
        row.TaskCreatedBy,
        row.TaskCompletedOn,
        row.TaskCompletedBy,
      ]);
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "evidence_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <div className="app-main__inner !pl-20 ">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Evidence Tasks
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all completed and in-progress evidence tasks
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              <Button
                variant="outlined"
                size="sm"
                onClick={exportToExcel}
                loading={isLoading === null ? true : false}
              >
                <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
              </Button>
              {rbac?.evidenceAdd ? (
                <>
                  <Button
                    onClick={handleOpenCreateDialog}
                    className="flex items-center gap-3"
                    size="sm"
                    loading={isLoading === null ? true : false}
                  >
                    <UserPlusIcon strokeWidth={2} className="h-4 w-4" />
                    <span className="hidden md:inline-block"> Create New</span>
                  </Button>
                </>
              ) : null}
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                label="Select Limit"
                className="!border-t-0 !border-[#b0bec5] custom-dropdown-menu"
                menuProps={{
                  offset: {
                    mainAxis: 10,
                    crossAxis: 0,
                    alignmentAxis: 0,
                  },
                }}
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                menuPlacement="bottom"
                label="Sort By"
                className="!border-t-0 !border-[#b0bec5]"
                value={sortBy}
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
              <Select
                color="green"
                className="!border-t-0 !border-[#b0bec5]"
                animate={{
                  mount: { y: 0 },
                  unmount: { y: 25 },
                }}
                label="Audit ID"
                menuProps={{
                  placement: "bottom-start",
                }}
                onChange={(event) => {
                  setAuditId(event);
                  setIsLoading(null);
                }}
                value={auditId}
              >
                <Option value="">All Data</Option>
                {templateData && templateData?.length > 0 ? (
                  templateData?.map((item) => (
                    <Option key={item?.AuditId} value={item?.AuditId}>
                      {item?.AuditId}
                    </Option>
                  ))
                ) : (
                  <Option value="">Loading...</Option>
                )}
              </Select>
              <Select
                color="yellow"
                label="Task Status"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setStatus(event);
                  setIsLoading(null);
                }}
                value={status}
              >
                <Option value="">Select Status</Option>
                <Option value="schedule">Scheduled</Option>
                <Option value="In Progress">In Progress</Option>
                <Option value="Completed">Completed</Option>
                <Option value="onHold">On Hold</Option>
                <Option value="canceled">Cancelled</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto">
              <Input
                label="Search"
                value={searchBy}
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-scroll px-3 p-0">
          <table className="mt-4 w-full min-w-max table-auto text-left ">
            <thead>
              <tr>
                {TABLE_HEAD.map((head, index) => (
                  <th
                    key={head}
                    className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-32"
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                    >
                      {head}{" "}
                      {index !== TABLE_HEAD.length - 1 && (
                        <ChevronUpDownIcon
                          strokeWidth={2}
                          className="h-4 w-4"
                        />
                      )}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            {isLoading === null ? (
              <>
                <tbody>
                  <tr>
                    <td colSpan={TABLE_HEAD.length}>
                      <TableSkeleton />
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <tbody>
                  {isLoading === false && templateData?.length > 0 ? (
                    templateData?.map(
                      (
                        {
                          taskId,
                          AuditId,
                          TaskRequirements,
                          TaskAssignee,
                          TaskStatus,
                          TaskCreatedOn,
                          TaskCreatedBy,
                          TaskCompletedOn,
                          TaskCompletedBy,
                          _id,
                        },
                        index
                      ) => {
                        const isLast = index === templateData.length - 1;
                        const classes = isLast
                          ? "p-3"
                          : "p-3 border-b border-blue-gray-50";

                        return (
                          <tr key={`${taskId}-${index}`}>
                            <td className={classes}>
                              <div className="flex items-center gap-3">
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal"
                                >
                                  {taskId}
                                </Typography>
                              </div>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {AuditId}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {/* {TaskRequirements.length > 40 ? (
                                  <TableRowWithShowMore
                                    data={TaskRequirements}
                                  />
                                ) : (
                                  TaskRequirements
                                )} */}

                                {/* Show button if TaskRequirements exists */}
                                {/* {TaskRequirements.length > 0 ? (
                                  <Button
                                    size="sm"
                                    className="mt-2"
                                    onClick={toggleDialog}
                                  >
                                    Show
                                  </Button>
                                ) : (
                                  TaskRequirements
                                )} */}
                                {TaskRequirements?.length > 1 ? (
                                  <Button
                                    size="sm"
                                    className="mt-2"
                                    onClick={() =>
                                      toggleDialog(TaskRequirements)
                                    }
                                  >
                                    Show
                                  </Button>
                                ) : TaskRequirements?.length === 1 ? (
                                  <div>{TaskRequirements[0]?.requirement}</div>
                                ) : (
                                  <div>No Requirements</div>
                                )}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {TaskAssignee}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <div className="w-max">
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  color={
                                    TaskStatus === "schedule"
                                      ? "blue"
                                      : TaskStatus === "In Progress"
                                      ? "orange"
                                      : TaskStatus === "Completed"
                                      ? "green"
                                      : TaskStatus === "Pending"
                                      ? "yellow"
                                      : TaskStatus === "canceled"
                                      ? "red"
                                      : null
                                  }
                                  value={
                                    TaskStatus === "schedule"
                                      ? "Schedule"
                                      : TaskStatus === "In Progress"
                                      ? "In Progress"
                                      : TaskStatus === "Completed"
                                      ? "Completed"
                                      : TaskStatus === "Pending"
                                      ? "On Hold"
                                      : TaskStatus === "canceled"
                                      ? "Canceled"
                                      : null
                                  }
                                />
                              </div>
                            </td>
                            <td className={classes}>
                              <Chip
                                variant="ghost"
                                size="sm"
                                value={
                                  TaskCreatedOn
                                    ? moment(TaskCreatedOn).format(
                                        "MMMM DD, YYYY"
                                      )
                                    : ""
                                }
                                className="rounded-full w-fit text-xs	normal-case font-medium	"
                              />
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {TaskCreatedBy}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Chip
                                variant="ghost"
                                size="sm"
                                value={
                                  TaskCompletedOn
                                    ? moment(TaskCompletedOn).format(
                                        "MMMM DD, YYYY"
                                      )
                                    : null
                                }
                                className="rounded-full w-fit text-xs	normal-case font-medium	"
                              />
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {TaskCompletedBy?.clientLegalName}
                              </Typography>
                            </td>
                            {rbac?.evidenceEdit ? (
                              <>
                                <td className={classes}>
                                  <Tooltip
                                    className="bg-blue-gray-500"
                                    content="Edit"
                                  >
                                    <IconButton
                                      variant="text"
                                      onClick={() => handleOpen(_id)}
                                    >
                                      <PencilIcon className="h-4 w-4" />
                                    </IconButton>
                                  </Tooltip>
                                </td>
                              </>
                            ) : (
                              <td></td>
                            )}
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td colSpan="8">
                        <div className="flex flex-col items-center w-full">
                          <img
                            quality={100}
                            src="/assets/images/9276430.jpg"
                            className="w-[350px] mix-blend-darken"
                            alt="no-data-found"
                          />
                          <p className="text-[20px] font-medium">
                            No Data Found!
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </>
            )}
          </table>
        </CardBody>
        {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page - 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Previous
              </Button>
              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setPage(index + 1);
                      setIsLoading(null);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                ))
                  .reduce((acc, button, index, array) => {
                    if (
                      index < 3 ||
                      index >= totalPage - 3 ||
                      (index >= Math.max(page - 1, 3) &&
                        index <= Math.min(page + 1, totalPage - 4))
                    ) {
                      acc.push(button);
                    } else if (acc[acc.length - 1] !== "ellipsis") {
                      acc.push("ellipsis");
                    }
                    return acc;
                  }, [])
                  .map((element, index, array) => {
                    return element === "ellipsis" ? (
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    ) : index > 0 && array[index - 1] === "ellipsis" ? (
                      <React.Fragment key={`fragment-${index}`}>
                        {element}
                      </React.Fragment>
                    ) : (
                      element
                    );
                  })}
              </div>

              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page + 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Next
              </Button>
            </CardFooter>
          </>
        )}
      </Card>

      {/* Dialog for Task ID and Task Requirements */}
      <Dialog open={isDialogOpen} handler={toggleDialog}>
        <DialogHeader>Task Details</DialogHeader>
        <DialogBody divider>
          <table className="w-full border-collapse border border-gray-200">
            <thead>
              <tr>
                <th className="border border-gray-300 px-4 py-2">Task ID</th>
                <th className="border border-gray-300 px-4 py-2">
                  Requirements
                </th>
              </tr>
            </thead>
            <tbody>
              {multipleRequirementData &&
                multipleRequirementData?.map(
                  ({ requirement, controlId }, index) => (
                    <tr key={index}>
                      <td className="border border-gray-300 px-4 py-2">
                        {controlId}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {requirement}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </DialogBody>
        <DialogFooter>
          <Button variant="outlined" color="red" onClick={toggleDialogClose}>
            Close
          </Button>
        </DialogFooter>
      </Dialog>

      {/* Edit evidence task */}
      <Dialog
        size="sm"
        open={open}
        handler={handleOpen}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <Card className="mx-auto w-full">
          <CardBody className="flex flex-col gap-2">
            <Typography variant="h4" color="blue-gray">
              Edit | Evidence
            </Typography>
            {editLoading ? (
              <>
                <div className="space-y-4">
                  <div className="w-32 h-8 bg-gray-300 animate-pulse rounded-md" />

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded-md mb-2" />
                      <div className="w-full h-12 bg-gray-300 animate-pulse rounded-md" />
                    </div>

                    <div>
                      <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded-md mb-2" />
                      <div className="w-full h-12 bg-gray-300 animate-pulse rounded-md" />
                    </div>

                    <div>
                      <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded-md mb-2" />
                      <div className="w-full h-12 bg-gray-300 animate-pulse rounded-md" />
                    </div>

                    <div>
                      <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded-md mb-2" />
                      <div className="w-full h-12 bg-gray-300 animate-pulse rounded-md" />
                    </div>

                    <div>
                      <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded-md mb-2" />
                      <div className="w-full h-12 bg-gray-300 animate-pulse rounded-md" />
                    </div>

                    <div>
                      <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded-md mb-2" />
                      <div className="w-full h-12 bg-gray-300 animate-pulse rounded-md" />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Task Requirements
                    </Typography>
                    <Input
                      label="Requirement"
                      name="taskRequirements"
                      onChange={handleInputChange}
                      size="lg"
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                  </div>
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Assignee
                    </Typography>
                    <Input
                      type="text"
                      name="TaskAssignee"
                      label="Assign"
                      onChange={handleInputChange}
                      size="lg"
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                  </div>
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Start Date
                    </Typography>
                    <Input
                      value={
                        moment(forEditEvidenceData.TaskCreatedOn).format(
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      disabled
                      name="TaskCreatedOn"
                      type="date"
                      label="Created On"
                      size="lg"
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                  </div>
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Completion Date
                    </Typography>
                    <Input
                      name="TaskCompletedOn"
                      onChange={handleInputChange}
                      type="date"
                      label="Completed On"
                      size="lg"
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                  </div>
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Status
                    </Typography>
                    <Select
                      onChange={(e) =>
                        handleInputChange({
                          target: { name: "TaskStatus", value: e },
                        })
                      }
                      label="Task Status"
                      color="purple"
                    >
                      <Option value="">Select Status</Option>
                      {/* <Option value="schedule">Scheduled</Option> */}
                      <Option value="In Progress">In Progress</Option>
                      <Option value="Completed">Completed</Option>
                      <Option value="Pending">Pending</Option>
                      {/* <Option value="cancelled">Cancelled</Option> */}
                    </Select>
                  </div>
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Remarks
                    </Typography>
                    <Input
                      label="Task Remarks"
                      name="TaskRemarks"
                      size="lg"
                      onChange={handleInputChange}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                  </div>
                  <div className="col-span-2">
                    <Typography className="mb-2" variant="h6">
                      Documents
                    </Typography>
                    <div className="grid grid-cols-2 gap-2">
                      {forEditEvidenceData.TaskRequirements?.map(
                        ({ requirement, controlId }, index) => (
                          <label
                            key={index}
                            className="flex items-center gap-2"
                          >
                            <input
                              type="checkbox"
                              name="documents"
                              value={controlId}
                              onChange={handleCheckboxChange}
                            />
                            <span>{requirement}</span>
                          </label>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </CardBody>
          <CardFooter className="flex justify-end border-t-2 py-2">
            <Button
              variant="text"
              color="red"
              onClick={handleClose}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
            <Button
              variant="gradient"
              color="green"
              onClick={() => handleSubmit(forEditEvidenceData?._id)}
              disabled={!allSelected}
            >
              {submitLoading ? (
                <p>Loading.</p>
              ) : (
                <>
                  <span>Submit</span>
                </>
              )}
            </Button>
          </CardFooter>
        </Card>
      </Dialog>

      {/* create new evidence task */}
      <Dialog
        size="sm"
        open={openCreateDialog}
        handler={() => setOpenCreateDialog(false)}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={createEvidanceTask}>
          <Card className="mx-auto w-full">
            <CardBody className="flex flex-col gap-4">
              <Typography variant="h4" color="blue-gray">
                Create Evidence Task
              </Typography>
              <div className="grid grid-cols-1 gap-4">
                <div>
                  <Typography className="mb-1" variant="h6">
                    Select Audit Id
                  </Typography>
                  <Select
                    onChange={(e) => handleChangeSelect(e)}
                    value={selectedAuditId}
                    label="Audit Id"
                    color="purple"
                  >
                    {auditData?.length > 0 ? (
                      auditData.map(({ auditName }, index) => (
                        <Option key={index} value={auditName}>
                          {auditName}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>No data found</Option>
                    )}
                  </Select>
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleOpenCreateDialog}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>
              <Button variant="gradient" type="submit" color="green">
                <span>Submit</span>
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Dialog>
    </div>
  );
}
